import { __read } from "tslib";
import React, { useEffect, useState } from 'react';
import { Tooltip, Tree } from '@hose/eui';
import styles from './filter.module.less';
import { getDisplayName } from "../utilFn";
import { NameCell } from '../name-cell';
var DepartmentTree = function (_a) {
    var treeData = _a.treeData, onChange = _a.onChange, value = _a.value, className = _a.className;
    var _b = __read(useState(value), 2), checkedKeys = _b[0], setCheckedKeys = _b[1];
    var _c = __read(useState(treeData === null || treeData === void 0 ? void 0 : treeData.map(function (item) { return item.id; })), 2), defaultExpandedKeys = _c[0], setDefaultExpandedKeys = _c[1];
    useEffect(function () {
        setDefaultExpandedKeys(treeData === null || treeData === void 0 ? void 0 : treeData.map(function (item) { return item.id; }));
    }, [treeData]);
    useEffect(function () {
        setCheckedKeys(value);
    }, [value]);
    var handleCheck = function (value, e) {
        onChange('tree', value.checked, e.node.key);
    };
    if (!(defaultExpandedKeys === null || defaultExpandedKeys === void 0 ? void 0 : defaultExpandedKeys.length)) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(Tree, { className: className, treeData: treeData, fieldNames: { title: 'name', key: 'id' }, onCheck: handleCheck, checkedKeys: checkedKeys, defaultExpandedKeys: defaultExpandedKeys, titleRender: function (nodeData) { return React.createElement(TreeTitle, { nodeData: nodeData }); }, style: { width: '100%' }, checkStrictly: true, checkable: true, selectable: false, height: 200, virtual: true, blockNode: true }));
};
var TreeTitle = function (_a) {
    var nodeData = _a.nodeData;
    var contentRef = React.createRef();
    var _b = __read(useState(false), 2), needTooltip = _b[0], setNeedTooltip = _b[1];
    var handleMouseEnter = function (e) {
        var _a, _b, _c, _d;
        setNeedTooltip(((_c = (_b = (_a = contentRef.current) === null || _a === void 0 ? void 0 : _a.parentNode) === null || _b === void 0 ? void 0 : _b.parentNode) === null || _c === void 0 ? void 0 : _c.offsetWidth) < ((_d = contentRef.current) === null || _d === void 0 ? void 0 : _d.offsetWidth));
    };
    var name = React.createElement(NameCell, { type: "department", id: nodeData.id, name: getDisplayName(nodeData) });
    return (React.createElement("span", { ref: contentRef, className: "" + styles['text-nowrap-ellipsis'], onMouseEnter: handleMouseEnter }, needTooltip ? (React.createElement(Tooltip, { placement: "topLeft", title: name }, name)) : (name)));
};
export default DepartmentTree;
